import { fetchHandler } from "../Handler/Handler";

export const POSTVendorDESC = async (slugname, data) => {
  try {
    const response = await fetchHandler({
      method: "POST",
      endpoint: `/description/vendor/${slugname}/descriptionname`,
      data,
    });
    return response;
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};
export const GetVendordescriptions = async (slugname) => {
  try {
    const response = await fetchHandler({
      method: "GET",
      endpoint: `/description/vendor/${slugname}/getdescriptions`,
      data: null,
    });
    return response;
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};

export const GETSingleDES = async (slugname, id) => {
  try {
    const response = await fetchHandler({
      method: "GET",
      endpoint: `/description/vendor/${slugname}/getdescriptions/${id}`,
      data: null,
    });
    return response;
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};

export const UpdateDESVendor = async (slugname, data, id) => {
  try {
    const response = await fetchHandler({
      method: "PUT",
      endpoint: `/description/vendor/${slugname}/updatedescription/${id}`,
      data: data,
    });
    return response;
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};
export const UpdatestatusVendorDES = async (slugname, data, id) => {
  try {
    const response = await fetchHandler({
      method: "PATCH",
      endpoint: `/description/vendor/${slugname}/statusdescription/${id}`,
      data: data,
    });
    return response;
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};
export const DELETEDESvendor = async (slugname, id) => {
  try {
    const response = await fetchHandler({
      method: "DELETE",
      endpoint: `/description/vendor/${slugname}/deletedescription/${id}`,
    });
    return response;
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};

export const GetDescriptionNamesBySubcategory = async (subcategoryId) => {
  try {
    const response = await fetchHandler({
      method: "GET",
      endpoint: `/description/admin/descriptionnames/${subcategoryId}`,
      data: null,
    });

    return response;
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};
